import { createAsyncThunk } from '@reduxjs/toolkit';
import authServiceApiInstance from '../../../../config/apiConfig';
import { ConfigurationSetting } from './configurationSettingsTypes';

// Create
export const createConfigSetting = createAsyncThunk(
  'configSetting/create',
  async (data: ConfigurationSetting, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.post('/configuration-settings', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create configuration setting');
    }
  }
);

// Get All
export const fetchAllConfigSettings = createAsyncThunk(
  'configSetting/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.get('/configuration-settings');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch configuration settings');
    }
  }
);

// Get By ID
export const fetchConfigSettingById = createAsyncThunk(
  'configSetting/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await authServiceApiInstance.get(`/configuration-settings/${id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch configuration setting');
    }
  }
);

// Update
export const updateConfigSetting = createAsyncThunk(
  'configSetting/update',
  async ({ id, data }: { id: number; data: ConfigurationSetting }, { rejectWithValue }) => {
    try {
      await authServiceApiInstance.put(`/configuration-settings/${id}`, data);
      return { id, data };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update configuration setting');
    }
  }
);
